import Scorecard from './scorecard';

// Due to a bug in redux behavior in frontend the submission payload might contain answers
// of a different submission. This method is used to filter them
function questionBelongsToSurvey(questionUuid, surveyPayload) {
  return !!surveyPayload.sections
    .find((section) => section.questions
      .find((question) => question.question.uuid === questionUuid));
}

function accumulateAnswer(questionUuid, answer, sampleIdx, sectionIdx, scorecard) {
  if (answer) {
    switch (answer.type) {
      case 'OneOf':
        scorecard.accumulate(sampleIdx, sectionIdx, `${questionUuid}.${answer.answer}`);
        break;
      case 'MultipleChoice':
        Object.keys(answer.choices).forEach((choiceUuid) => answer.choices[choiceUuid]
          && scorecard.accumulate(sampleIdx, sectionIdx, `${questionUuid}.${choiceUuid}`));
        break;
      case 'ArbitraryString':
        scorecard.accumulateFreeText(sampleIdx, sectionIdx, questionUuid, answer.answer);
        break;
      case 'IntegerPercentage':
        break;
      default:
        throw new Error(`Unsupported answer type for accumulation: ${answer.type} - ${JSON.stringify(answer)}`);
    }
  }
}

export function aggregateSubmissions(submissions, surveyPayload) {
  const res = submissions
    .filter((submission) => !!submission.payload.sections)
    .map((submission) => submission.payload.sections)
    .map((submissionSections) => submissionSections
      .filter((submissionSection) => !!submissionSection)
      .map((submissionSection) => Object.keys(submissionSection.questions)
        // TODO: iterate over surveyPayload instead
        .filter((key) => questionBelongsToSurvey(key, surveyPayload))
        .map((key) => ({ answers: submissionSection.questions[key], question: key }))))
    .reduce((scorecard, submissionQuestionPayloads) => {
      submissionQuestionPayloads.forEach((submissionSectionQuestions, sectionIdx) => {
        submissionSectionQuestions.forEach((questionAndAnswers) => {
          questionAndAnswers.answers.answers
            .forEach((answer, sampleIdx) => accumulateAnswer(
              questionAndAnswers.question, answer, sampleIdx, sectionIdx, scorecard,
            ));
        });
      });
      return scorecard;
    }, new Scorecard(surveyPayload));

  return res;
}

export function validateScoresOrThrow(scorecard) {
  const sampleSums = scorecard.getSampleSums();
  if (!sampleSums.every((section) => section.every((sum) => sum > 0))) {
    throw new Error(
      `Scorecard error: the sum of a sample is invalid: ${JSON.stringify(sampleSums)}`,
    );
  }
}
